import React from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { usePropertyReader } from '@/hooks/usePropertyReader'
import { decimalMaxChangeItemValue } from '@/utils/constants'

const SharesAmount = ({ target }) => {
  const [relatedPersonType] = usePropertyReader(['relatedPersonType'])
  if (relatedPersonType && relatedPersonType.code === 'Fndr') {
    return <FormRow label='Individuals.SharesAmount' name='sharesAmount' target={target} inputType='number' required inputProps={{ min: 0 }} maxValue={decimalMaxChangeItemValue} />
  }
  return null
}

const BoardMember = ({ target }) => {
  const [relatedPersonType] = usePropertyReader(['relatedPersonType'])
  if (relatedPersonType && relatedPersonType.code === 'Brdm') {
    return <React.Fragment>
      <FormRow label='Individuals.ContributionAmount' name='contributionAmount' target={target} inputType='number' required inputProps={{ min: 0 }} maxValue={decimalMaxChangeItemValue} />
      <FormRow label='CodeLists.MembershipType' name='membershipType' target={target} inputType='dropdown' dataSource={() => context.api.codeListService.getCodeList('MembershipType')}
        isCodeList required />
      <FormRow label='CodeLists.DegreeOfMembership' name='degreeOfMembership' target={target} inputType='dropdown' dataSource={() => context.api.codeListService.getCodeList('DegreeOfMembership')}
        isCodeList required />
      <FormRow label='Individuals.IsGeneralManager' name='isGeneralManager' target={target} inputType='checkbox' />
    </React.Fragment>
  }
  return null
}

function RelatedInstitutionDialog (props) {
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Individuals.RelatedInstitution' {...props} />
        <ModalBody>
          <Row>
            <div className='col-12'>
              {context.isInternalApp() && <FormRow label='Individuals.Institution' name='institution' target={props.target} inputType='dropdown' dataSource={context.api.institutionService.getLookup} required />}
              <FormRow label='Individuals.RelatedPersonType' name='relatedPersonType' target={props.target} inputType='lookup' dataSource={context.cache.getRelatedPersonTypes} clientSide isCodeList required />
              <SharesAmount target={props.target} />
              <BoardMember target={props.target} />
              <ValidDates toKey='Individuals.DateOfLeavingPosition' target={props.target} />
              <FormRow label='Individuals.NotValidForPurpose' target={props.target} name='notValidForPurpose' inputType='textarea' />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  component: RelatedInstitutionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/relatedInstitution.js